<template>
    <MultiSelect
        :modelValue="selections"
        :options="options"
        :placeholder="placeholder"
        @change="$emit('handleSelection', $event.value)"
        optionLabel="name"
        :filter="true"
        class="multiselect-custom"
    >
        <template #value="slotProps">
            <div class="item-value" v-for="option of slotProps.value" :key="option.key">
                <div>{{ option.name }}</div>
            </div>
            <template v-if="!slotProps.value || slotProps.value.length === 0">
                {{ placeholder }}
            </template>
        </template>
        <template #option="slotProps">
            <div>
                {{ slotProps.option.name }}
                <i
                    class="pi pi-info-circle"
                    text-500
                    v-if="slotProps.option.desc"
                    v-tooltip="{ value: slotProps.option.desc }"
                    style="position: absolute; right: 3px"
                ></i>
            </div>
        </template>
    </MultiSelect>
</template>

<script>
export default {
    props: {
        options: {
            required: true,
        },
        placeholder: {
            required: true,
        },
        selections: {
            required: true,
        },
    },
};
</script>

<style scoped></style>
